import {
  subscribeToWaitlistActionCreator,
  WAITLIST_SUBSCRIBE_CLICKED,
} from '../actions';
import { getContentApiUrl } from '../selectors';
import fetchJson from './fetchJson';

const postSubscription = async (apiUrl, payload) => (
  fetchJson('newsletter', [apiUrl, 'newsletter', 'subscribe'].join('/'), null, payload, 'post')
);

const dispatchPostSubscription = (store, sliceId, payload) => {
  const state = store.getState();
  const apiUrl = getContentApiUrl(state);
  store.dispatch(subscribeToWaitlistActionCreator(
    sliceId,
    postSubscription(apiUrl, payload),
  ));
};

export default store => next => action => {
  const ret = next(action);
  switch (action.type) {
    case WAITLIST_SUBSCRIBE_CLICKED:
      dispatchPostSubscription(store, action.meta.sliceId, action.payload);
      break;
    // no default
  }
  return ret;
};
